import { useCallback, useEffect, useState } from 'react'
import { importElfGameJS } from '../controllers/elf/items/import'
import { useContent } from '../redux/reducer/content'
import { conturs, defaultContur } from '../translations'
import { MAIN } from '../constants/shared/states/names'

export const GIFT_ME_INTERACTIVE_NAME = 'giftMe'
// !TODO заменить после теста на актуальную дату
export const GIFT_ME_INTERACTIVE_START_DATE = new Date('2026-05-29T00:00:00')
export const GIFT_ME_INTERACTIVE_END_DATE = new Date('2026-06-07T23:59:59')

export const getIsGiftMeInteractiveActive = () => {
  const now = new Date()

  return now >= GIFT_ME_INTERACTIVE_START_DATE && now <= GIFT_ME_INTERACTIVE_END_DATE
}

export const useGiftMeInteractive = () => {
  const { state, isBath } = useContent()
  const [wrapper, setWrapper] = useState()
  const isMeContur = defaultContur === conturs.me

  const updateVisibility = useCallback(() => {
    if (!wrapper) {
      return
    }

    const isVisible = isMeContur && state === MAIN && !isBath && getIsGiftMeInteractiveActive()

    wrapper.setInteractiveVisible(GIFT_ME_INTERACTIVE_NAME, isVisible)
  }, [wrapper, isMeContur, state, isBath])

  useEffect(() => {
    ;(async () => {
      const { wrapper: elfWrapper } = await importElfGameJS()

      setWrapper(elfWrapper)
    })()
  }, [])

  useEffect(() => {
    updateVisibility()
  }, [updateVisibility])

  return updateVisibility
}
